import { render, staticRenderFns } from "./menuBar.vue?vue&type=template&id=776e4e54&scoped=true"
import script from "./menuBar.vue?vue&type=script&lang=js"
export * from "./menuBar.vue?vue&type=script&lang=js"
import style0 from "./menuBar.vue?vue&type=style&index=0&id=776e4e54&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "776e4e54",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/hybrid-app/ph-refusaldrainage-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('776e4e54')) {
      api.createRecord('776e4e54', component.options)
    } else {
      api.reload('776e4e54', component.options)
    }
    module.hot.accept("./menuBar.vue?vue&type=template&id=776e4e54&scoped=true", function () {
      api.rerender('776e4e54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/menuBar.vue"
export default component.exports